import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitEnquiry(payload) {
  const res = await axios.post(`${API}/enquiries`, payload);
  return res.data;
}

export { API };
